import { render, staticRenderFns } from "./select-client-dialog.vue?vue&type=template&id=5ac53dbe"
import script from "./select-client-dialog.vue?vue&type=script&lang=js"
export * from "./select-client-dialog.vue?vue&type=script&lang=js"
import style0 from "./select-client-dialog.vue?vue&type=style&index=0&id=5ac53dbe&prod&module=true&lang=less"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports